var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 155,
    viewBox: "0 0 270 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1319_266667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1831 28.0654C94.1831 20.2973 100.48 14 108.248 14H159.235C167.003 14 173.301 20.2973 173.301 28.0654V79.0523C173.301 86.8204 167.003 93.1176 159.235 93.1176H108.248C100.48 93.1176 94.1831 86.8204 94.1831 79.0523V28.0654Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1319_266667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.044 24.8789H142.479L146.724 29.1241V33.2222H118.044C116.028 33.2222 114.394 34.8565 114.394 36.8724V70.2457C114.394 72.2616 116.028 73.8959 118.044 73.8959H146.724V78.1414L142.626 82.2392H118.044C111.42 82.2392 106.051 76.8695 106.051 70.2457V36.8724C106.051 30.2486 111.42 24.8789 118.044 24.8789Z",
    fill: "#1554FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.566 41.5655C118.566 39.2616 120.433 37.3939 122.737 37.3939H157.153C159.457 37.3939 161.325 39.2616 161.325 41.5655C161.325 43.8695 159.457 45.7372 157.153 45.7372H122.737C120.433 45.7372 118.566 43.8695 118.566 41.5655Z",
    fill: "#1554FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.566 53.5591C118.566 51.2551 120.433 49.3874 122.737 49.3874H146.724C149.028 49.3874 150.896 51.2551 150.896 53.5591C150.896 55.863 149.028 57.7307 146.724 57.7307H122.737C120.433 57.7307 118.566 55.863 118.566 53.5591Z",
    fill: "#1554FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.566 65.5526C118.566 63.2486 120.433 61.3809 122.737 61.3809H136.295C138.599 61.3809 140.467 63.2486 140.467 65.5526C140.467 67.8565 138.599 69.7242 136.295 69.7242H122.737C120.433 69.7242 118.566 67.8565 118.566 65.5526Z",
    fill: "#1554FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.610352 137.88V121.941C0.610352 117.183 2.98944 114.804 7.74762 114.804H19.6577L22.2411 116.818V119.664H7.87898C6.59456 119.664 5.95236 120.292 5.95236 121.547V138.274C5.95236 139.529 6.59456 140.157 7.87898 140.157H22.2411V143.003L19.6577 145.017H7.74762C2.98944 145.017 0.610352 142.638 0.610352 137.88Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.959 138.099V122.029H31.082V138.536C31.082 139.879 31.7534 140.551 33.0962 140.551H40.3211V122.029H45.4442V145.017H32.8773C28.2651 145.017 25.959 142.711 25.959 138.099Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5859 143.309V140.551H59.7007C61.0435 140.551 61.7149 139.835 61.7149 138.405C61.7149 136.916 61.1602 136.07 60.051 135.865L55.1468 135.077C51.4395 134.435 49.5859 132.333 49.5859 128.772C49.5859 124.276 51.892 122.029 56.5042 122.029H63.4663L65.787 123.736V126.495H56.7232C55.3512 126.495 54.6652 127.21 54.6652 128.641C54.6652 130.071 55.249 130.888 56.4166 131.093L61.3208 131.881C64.9989 132.494 66.8379 134.61 66.8379 138.23C66.8379 142.755 64.5172 145.017 59.8758 145.017H51.9066L49.5859 143.309Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7635 138.099V114.804H75.8865V122.029H83.7244V126.495H75.8865V138.536C75.8865 139.879 76.5579 140.551 77.9007 140.551H84.1623V143.309L81.8416 145.017H77.6818C73.0696 145.017 70.7635 142.711 70.7635 138.099Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0896 138.099V128.947C87.0896 124.335 89.3957 122.029 94.0079 122.029H100.138C104.721 122.029 107.013 124.335 107.013 128.947V138.099C107.013 142.711 104.721 145.017 100.138 145.017H94.0079C89.3957 145.017 87.0896 142.711 87.0896 138.099ZM92.2127 138.536C92.2127 139.879 92.8841 140.551 94.2269 140.551H99.8754C101.218 140.551 101.89 139.879 101.89 138.536V128.509C101.89 127.166 101.218 126.495 99.8754 126.495H94.2269C92.8841 126.495 92.2127 127.166 92.2127 128.509V138.536Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.638 145.017V122.029H137.823C142.406 122.029 144.697 124.335 144.697 128.947V145.017H139.574V128.509C139.574 127.166 138.903 126.495 137.56 126.495H130.729V145.017H125.606V126.495H116.761V145.017H111.638Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.169 138.099V128.947C149.169 124.335 151.475 122.029 156.088 122.029H161.78C166.363 122.029 168.655 124.335 168.655 128.947V135.428H154.292V138.536C154.292 139.879 154.964 140.551 156.307 140.551H167.779V143.309L165.458 145.017H156.088C151.475 145.017 149.169 142.711 149.169 138.099ZM154.292 131.443H163.531V128.509C163.531 127.166 162.86 126.495 161.517 126.495H156.307C154.964 126.495 154.292 127.166 154.292 128.509V131.443Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.115 145.017V124.875C174.166 122.977 176.18 122.029 179.158 122.029H183.755L186.076 123.736V126.495H180.34C179.347 126.495 178.647 126.743 178.238 127.239V145.017H173.115Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197.826 137.88V121.941C197.826 117.183 200.205 114.804 204.963 114.804H216.874L219.457 116.818V119.664H205.095C203.81 119.664 203.168 120.292 203.168 121.547V138.274C203.168 139.529 203.81 140.157 205.095 140.157H219.457V143.003L216.874 145.017H204.963C200.205 145.017 197.826 142.638 197.826 137.88Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M223.219 118.044V112.833H228.604V118.044H223.219ZM223.35 145.017V122.029H228.473V145.017H223.35Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M233.262 138.099V114.804H238.385V122.029H246.223V126.495H238.385V138.536C238.385 139.879 239.056 140.551 240.399 140.551H246.661V143.309L244.34 145.017H240.18C235.568 145.017 233.262 142.711 233.262 138.099Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247.486 122.817L248.012 122.029H252.434L258.214 140.551H258.871L264.651 122.029H269.073L269.599 122.817L259.572 153.774H255.149L254.624 152.986L257.382 145.017H254.711L247.486 122.817Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1319_266667",
    x: 74.4037,
    y: 0.813726,
    width: 118.676,
    height: 118.676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.59314
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.88971
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.186389 0 0 0 0 0.312642 0 0 0 0 0.508333 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1319_266667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1319_266667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1319_266667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.2745,
    height: 57.3603,
    fill: "white",
    transform: "translate(106.051 24.8789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/whiteLogo.a6d0161c6a4f74758ec9d5a32106552d.svg";
export { ForwardRef as ReactComponent };